import React from "react";
import "./nav.css";
//import NavMessage from "./NavMessage";
import NavAvatar from "./NavAvatar";
import NavNotice from "./NavNotice";

function Nav() {
  return (
    <nav className="header-nav ms-auto">
      <ul className="d-flex align-items-center">
        {/*  es la mcapana al lado superior derecha <NavNotice />*/}
        <NavNotice />
        {/* es la lista de notificaicones <NavMessage />*/}
        <NavAvatar />
      </ul>
    </nav>
  );
}

export default Nav;
